import { AnchorButton } from "@blueprintjs/core";
import { Stack, Text } from "@mantine/core";

export const SaveRuleUpsellPopover = () => {
  return (
    <Stack sx={{ width: "200px", whiteSpace: "break-spaces" }}>
      <Text color="dark">Create an account to save your rule!</Text>
      <AnchorButton
        intent="primary"
        href={`/login?return_path=${window.location.pathname}`}
      >
        Sign up
      </AnchorButton>
    </Stack>
  );
};
